import { Checkbox, EmailSelectorField } from "@certn/cascadia-react";
import { useField } from "formik";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

export function NotificationEmailsSection() {
  const { t } = useTranslation();
  const [{ value: rawEmails }, , { setValue: setEmails }] = useField<
    string[] | undefined
  >("additional_notification_emails");
  const emails = rawEmails ?? [];

  const [sendAdditionalEmails, setSendAdditionalEmails] = useState(
    () => emails.length > 0
  );
  const skipEmptyEmailsEffectRef = useRef(false);

  useEffect(() => {
    if (emails.length === 0 && sendAdditionalEmails) {
      if (skipEmptyEmailsEffectRef.current) {
        skipEmptyEmailsEffectRef.current = false;
        return;
      }
      setSendAdditionalEmails(false);
    }
  }, [emails.length, sendAdditionalEmails]);

  useEffect(() => {
    if (emails.length > 0) {
      setSendAdditionalEmails(true);
    }
  }, [emails.length]);

  return (
    <>
      <Checkbox
        testID="notification-emails-checkbox"
        isSelected={sendAdditionalEmails}
        description={t(
          "This email(s) will receive updates when a case is completed and ready for review"
        )}
        onChange={(selected) => {
          if (selected) {
            skipEmptyEmailsEffectRef.current = true;
            setSendAdditionalEmails(true);
            void setEmails([]);
          } else {
            setSendAdditionalEmails(false);
            void setEmails([]);
          }
        }}
      >
        {t("Send additional notification email")}
      </Checkbox>
      {sendAdditionalEmails ? (
        <EmailSelectorField
          name="additional_notification_emails"
          testID="notification-emails"
          label={t("Send to")}
          description={t(
            "Add one or more email addresses to receive notifications when a case is completed"
          )}
        />
      ) : null}
    </>
  );
}
